const Layout = () => import('@/layout/index.vue')

export default {
    path: '/setting',
    component: Layout,
    redirect: '/setting/customer',
    name: 'Setting',
    meta: {
        title: '运营管理',
        icon: 'setting',
        auth: ['Setting']
    },
    children: [
        {
            path: 'customer',
            name: 'SettingCustomer',
            component: () => import('@/views/setting/customer/index.vue'),
            meta: {
                title: '客服管理',
                icon: 'setting-customer',
                auth: ['SettingCustomer']
            }
        },
        {
            path: 'toolmanagement',
            name: 'Toolmanagement',
            component: () => import('@/views/setting/toolmanagement/index.vue'),
            meta: {
                title: '工具管理',
                icon: 'tools',
                auth: ['Toolmanagement']
            }
        },
        {
            path: 'businessBriefing',
            name: 'BusinessBriefing',
            component: () => import('@/views/setting/businessBriefing/index.vue'),
            meta: {
                title: '数据大屏',
                icon: 'briefing',
                auth: ['BusinessBriefing']
            }
        },
        {
            path: 'notice',
            name: 'SettingNotice',
            component: () => import('@/views/setting/notice/index.vue'),
            meta: {
                title: '公告设置',
                icon: 'setting-notice',
                auth: ['SettingNotice']
            }
        },        {
            path: 'banner',
            name: 'Banner',
            component: () => import('@/views/setting/banner/index.vue'),
            meta: {
                title: '轮播图管理',
                icon: 'setting-banner',
                autho: ['Banner']
            }
        },
       
        {
            path: 'introduction',
            name: 'Introduction',
            component: () => import('@/views/setting/introduction/index.vue'),
            meta: {
                title: '介绍和问题',
                icon: 'appSetting',
                auth: ['Introduction']
            }
        },
        // {
        //     path: 'OEMmanagement',
        //     name: 'OEMmanagement',
        //     component: () => import('@/views/setting/OEMmanagement/index.vue'),
        //     meta: {
        //         title: 'OEM管理',
        //         icon: 'users'
        //     }
        // },
        {
            path: 'appSetting',
            name: 'AppSetting',
            component: () => import('@/views/setting/appSetting/index.vue'),
            meta: {
                title: '应用配置',
                icon: 'appSetting'
            }
        }
    ]
}
